import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 8F694E89-2460-4790-820F-BCFA1A4CB660
 * name share-off
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/share-off.svg
 * tags
 * - Arrow 
 */
export const ShareOffIcon = createSvgIcon(<><path d="M20.8 22.7L15.6 17.5L14 19V15.9L13.1 14.9C8.6 15.2 5.4 16.8 3 20.1C3.58 16.31 5.72 12.94 8.9 10.8L1.1 3L2.4 1.7L22.1 21.5M18.1 14.9L21 12L14 5V9L12.5 9.3" /></>, 'ShareOffIcon');
export default ShareOffIcon